export interface ElasticApiHit<T> {
  _index: string;
  _type: string;
  _id: string;
  _score: number;
  _source: T;
}

export interface ElasticApiResponse<T> {
  took: number;
  timed_out: boolean;
  _shards: {
    total: number;
    successful: number;
    skipped: number;
    failed: number;
  };
  hits: {
    total: { value: number; relation: 'gte' | 'eq' };
    max_score: number;
    hits: ElasticApiHit<T>[];
  };
}

export enum ElasticRelatedType {
  Customer = 0,
  ShipTo = 1,
  Prospect = 2,
}

export enum ElasticStatus {
  Customer = 2,
  Prospect = 1,
}

export interface ElasticApiRequest {
  status: ElasticStatus;
  query?: string;
}

export interface ElasticApiCustomersRequest extends ElasticApiRequest {
  status: ElasticStatus;
  customerIds?: number[];
}

export interface ElasticApiLocationsRequest extends ElasticApiRequest {
  status: ElasticStatus;
  shipToIds?: number[];
  customerIds?: number[];
}

export interface ElasticApiSkuCatalogRequest {
  keywords: string;
  language: string;
  size?: number;
  from?: number;
  salesOrganization: string;
}

export interface ElasticApiRelationsRequest {
  relatedType: ElasticRelatedType;
}

export interface ElasticRelation {
  ProfileId: number;
  RelatedId: number;
  RelatedType: ElasticRelatedType;
}

export interface ElasticSalesArea {
  DistributionChannel: string;
  Division: string;
  OrderBlock: boolean;
  SalesOrganization: string;
}

export interface ElasticSilo {
  Id: string;
  Name: string;
}

export interface ElasticShipTo {
  Id: number;
  Name: string;
  Street: string;
  PostalCode: string;
  HouseNumber: string;
  HouseNumberAddition: string;
  City: string;
  Country: string;
}

export interface ElasticLocation extends ElasticShipTo {
  ExternalId: string;
  MobileNumber: string;
  OrderBlock: boolean;
  PhoneNumber: number;
  SalesAreas: ElasticSalesArea[];
  Silos: ElasticSilo[];
  Customer: ElasticCustomer;
  CustomerId: number;
}

export enum ElasticCustomerStatus {
  Prospect = 'Prospect',
  Customer = 'Customer',
}

export interface ElasticCustomer {
  City: string;
  Country: string;
  EmailAddress: string;
  ExternalId: string;
  FixDeliveryDays: number;
  HouseNumber: string;
  HouseNumberAddition: string;
  Id: number;
  MobileNumber: string;
  Name: string;
  OrderBlock: boolean;
  PhoneNumber: number;
  PostalCode: string;
  Status: ElasticCustomerStatus;
  Street: string;
  ShipTos: Location[];
}

export enum ElasticQueryString {
  Name = 'Name',
  CustomerExternalId = 'Customer.ExternalId',
  CustomerName = 'Customer.Name',
  ExternalId = 'ExternalId',
  EmailAddress = 'EmailAddress',
  City = 'City',
  Country = 'Country',
  PostalCode = 'PostalCode',
  Street = 'Street',
}
